
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24 12A12 12 0 1112 0a12 12 0 0112 12z","fill":"#ffd250"}}),_c('path',{attrs:{"d":"M12 14.42a2.23 2.23 0 102.23 2.23A2.23 2.23 0 0012 14.42zm-2.11-8l.36 6.58a.57.57 0 00.58.55h2.34a.57.57 0 00.58-.55l.36-6.58a.58.58 0 00-.58-.61h-3.06a.58.58 0 00-.58.61z","fill":"#fff"}})])
          )
        }
      }
    